import { Response } from '../types';

import { dsmOpsAxios } from '.';

type UploadFirmwareData = {
  firmwareVersion: string;
  files: File[];
};

export const uploadFirmwares = (data: UploadFirmwareData) => {
  const formData = new FormData();
  data.files.forEach((f) => {
    formData.append('files', f);
  });
  return dsmOpsAxios.post(
    `/v1/dasloop-protocol/firmware-files/${data.firmwareVersion}`,
    formData,
  );
};

type GetFirmwaresResponse = {
  firmwareVersion: string;
  createdAt: string;
  updatedAt: string;
  files: Array<{
    id: string;
    name: string;
    hardwareVersion: string;
    firmwareGroupId: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

export const getFirmwares = () => {
  return dsmOpsAxios.get<Response<GetFirmwaresResponse[]>>(
    `/v1/dasloop-protocol/firmware-files`,
  );
};

type DeleteFirmwareParams = {
  firmwareVersion: string;
  fileName: string;
};

export const deleteFirmware = (params: DeleteFirmwareParams) => {
  return dsmOpsAxios.delete<Response<GetFirmwaresResponse[]>>(
    `/v1/dasloop-protocol/firmware-files/${params.firmwareVersion}?fileName=${params.fileName}`,
  );
};
